export default {
  "auth.login": "Iniciar sesión",
  "auth.register": "Registrarse",
  "auth.email": "Correo electrónico",
  "auth.password": "Contraseña",
  "auth.logout": "Cerrar sesión",
  "auth.loginFailed": "Error de inicio de sesión",
  "auth.registerFailed": "Error en el registro de usuario",
  "nav.dashboard": "Panel de evaluación",
  "nav.activeEvaluations": "Evaluaciones activas",
  "nav.completedEvaluations": "Evaluaciones completadas",
  "nav.createNew": "Crear nueva evaluación",
  "nav.projectMerge": "Fusión de proyecto",
  "nav.share": "Configuración de compartir",
  "nav.copy": "Copiar",
  "nav.delete": "Eliminar",
  "nav.settings": "Configuración",
  "menu.language": "Configuración de idioma",
  "menu.colorPalette": "Paleta de colores",
  "status.inProgress": "En progreso",
  "status.completed": "Completado",
  "status.untitled": "Evaluación sin título",
  "stats.subjects": "Sujetos",
  "stats.criteria": "Criterios",
  "stats.progress": "Progreso",
  "step.criteriaExtraction": "Extracción de criterios",
  "step.comparison": "Ordenemos por calidad",
  "step.subjectRegistration": "Registro de sujetos",
  "form.evaluationPolicy": "Política de evaluación",
  "form.policyDescription": "Política de evaluación y puntos clave",
  "form.policyPlaceholder": "Ejemplo: Enfatizar la estructura lógica y evaluar la creatividad y originalidad",
  "btn.aiExtraction": "Extracción IA de criterios",
  "btn.manualAdd": "Agregar criterios manualmente",
  "btn.next": "Siguiente",
  "btn.back": "Atrás",
  "plan.free": "Plan gratuito",
  "plan.professional": "Profesional",
  "plan.business": "Negocio",
  "plan.school": "Escuela",
  "plan.unlimitedProjects": "Proyectos ilimitados",
  "plan.prioritySupport": "Soporte prioritario",
  "plan.dataExport": "Exportación de datos",
  "plan.monthlyRenewal": "Renovación automática mensual",
  "plan.cancelAnytime": "Cancelar en cualquier momento",
  "plan.paymentFailed": "Error al iniciar el pago",
  "confirm.delete": "¿Está seguro de que desea eliminar? Esta acción no se puede deshacer",
  "alert.appUpdate": "Actualización de la aplicación detectada",
  "alert.projectLimit": "Ha alcanzado el límite para crear proyectos de evaluación",
  "common.loading": "Cargando...",
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.confirm": "Confirmar",
  "common.error": "Error",
  "common.success": "Éxito",
  "date.today": "Hoy",
  "date.yesterday": "Ayer",
  "date.thisWeek": "Esta semana",
  "date.lastWeek": "La semana pasada",
  "error.dashboardLoad": "Error de carga del panel",
  "error.serverUnavailable": "No se puede conectar al servidor. Por favor intente de nuevo más tarde",
  "error.evaluationLimit": "Error al verificar el límite de evaluación",
  "error.loadingData": "Error de carga",
  "error.copyFailed": "Error de copia",
  "error.deleteFailed": "Error al eliminar",
  "error.copyProcess": "Se produjo un error durante el proceso de copia",
  "error.deleteProcess": "Se produjo un error durante el proceso de eliminación",
  "error.sharingUpdate": "Error al actualizar la configuración de compartir",
  "msg.loadingDashboard": "Cargando panel...",
  "msg.retry": "Reintentar",
  "msg.projectLimitReached": "Ha alcanzado el límite de creación de proyectos de evaluación",
  "msg.upgradeToProPlan": "Por favor actualice al plan PRO",
  "msg.cannotCreateProject": "No se puede crear proyecto de evaluación",
  "msg.freeLastProject": "El plan gratuito permite hasta 1 proyecto de evaluación. Esta es su última ranura disponible.",
  "msg.untitledProject": "Proyecto de evaluación sin título",
  "msg.welcome": "Bienvenido",
  "msg.welcomeWithName": "Bienvenido, {{name}}",
  "msg.created": "Creado",
  "msg.updated": "Actualizado",
  "msg.completed": "completado",
  "copy.title": "Creando una copia de \"{{title}}\"",
  "copy.newTitle": "Ingrese un nuevo título (deje en blanco para \"Título original (Copia)\")",
  "progress.completed": "completado",
  "common.initializing": "Inicializando aplicación...",
  "common.connecting": "Conectando...",
  "common.processing": "Procesando...",
  "common.required": "Requerido",
  "common.close": "Cerrar",
  "common.preview": "Vista previa",
  "common.edit": "Editar",
  "common.details": "Detalles",
  "common.position": "Posición",
  "common.rank": "Rango",
  "common.placed": "Colocado",
  "common.characters": "caracteres",
  "common.items": "elementos",
  "common.folders": "Carpetas",
  "common.files": "Archivos",
  "common.openInNewTab": "Abrir en nueva pestaña",
  "common.next": "Siguiente",
  "common.prev": "Anterior",
  "googleDrive.title": "Importar desde Google Drive",
  "googleDrive.connect": "Conectar a Google Drive",
  "googleDrive.description": "Para importar objetivos de evaluación desde Google Drive en lote, primero inicie sesión con su cuenta de Google.",
  "googleDrive.signIn": "Iniciar sesión con cuenta de Google",
  "modal.closeModal": "Cerrar modal",
  "invitation.invalid": "Token de invitación inválido",
  "invitation.accepted": "Invitación aceptada",
  "invitation.failed": "Error al aceptar la invitación",
  "invitation.title": "Invitación al proyecto de evaluación",
  "invitation.accept": "Aceptar invitación",
  "collaboration.viewResults": "Ver resultados de evaluación",
  "collaboration.addComments": "Añadir comentarios",
  "collaboration.downloadData": "Descargar datos",
  "collaboration.editCriteria": "Editar criterios de evaluación",
  "collaboration.manageProject": "Gestionar proyecto",
  "autoSave.settings": "Configuración de guardado automático",
  "autoSave.interval": "Intervalo de guardado",
  "autoSave.15seconds": "15 segundos",
  "autoSave.30seconds": "30 segundos",
  "autoSave.1minute": "1 minuto",
  "autoSave.2minutes": "2 minutos",
  "autoSave.5minutes": "5 minutos",
  "autoSave.saveNow": "Guardar ahora",
  "autoSave.saved": "Guardado",
  "autoSave.helpShort": "Guardar frecuentemente con intervalos cortos",
  "autoSave.helpMedium": "Frecuencia de guardado equilibrada",
  "autoSave.helpLong": "Ahorrar recursos con intervalos más largos",
  "weight.title": "Configuración de peso de evaluación general",
  "weight.description": "Por favor establezca el peso para cada criterio de evaluación. El peso total se ajustará al 100%.",
  "weight.equalDistribution": "Distribución igualitaria",
  "weight.criterion": "Criterio de evaluación",
  "weight.weight": "Peso (%)",
  "weight.maxScore": "Puntuación máxima",
  "weight.saveSettings": "Guardar configuración",
  "preview.title": "Vista previa de {{title}}",
  "preview.iframeBlocked": "Algunos sitios pueden bloquear la visualización dentro de iframes.",
  "preview.showPreview": "Mostrar vista previa",
  "preview.editDetails": "Editar detalles",
  "preview.available": "Vista previa disponible",
  "googleDrive.myDrive": "Mi unidad",
  "googleDrive.emptyFolder": "Esta carpeta está vacía",
  "googleDrive.filesSelected": " archivos seleccionados",
  "googleDrive.importSelected": "Importar archivos seleccionados",
  "dashboard.projectLimitReached": "Ha alcanzado el límite para crear proyectos de evaluación ({count} proyectos). Por favor actualice al plan PRO.",
  "dashboard.cannotCreateProject": "No se puede crear proyecto de evaluación.",
  "dashboard.freeLastProject": "El plan gratuito permite hasta 1 proyecto de evaluación. Esta es su última ranura disponible.",
  "dashboard.evaluationLimitCheckFailed": "Error al verificar el límite de evaluación.",
  "dashboard.loadingError": "Error de carga: {{message}}",
  "dashboard.copyError": "Error de copia: {{message}}",
  "dashboard.copyProcessError": "Se produjo un error durante el proceso de copia",
  "dashboard.deleteError": "Error de eliminación: {{message}}",
  "dashboard.deleteProcessError": "Se produjo un error durante el proceso de eliminación",
  "dashboard.shareSettingsUpdateFailed": "Error al actualizar la configuración de compartir",
  "dashboard.copyProjectTitle": "Creando una copia de \"{{title}}\".",
  "dashboard.copyProjectPrompt": "Ingrese un nuevo título (deje en blanco para \"Título original (Copia)\"):",
  "dashboard.deleteConfirm": "¿Eliminar \"{{title}}\"? Esta acción no se puede deshacer.",
  "dashboard.statusUnknown": "Desconocido",
  "dashboard.collaborators": "{{count}} colaboradores",
  "dashboard.menu": "Menú",
  "dashboard.shareSettings": "Configuración de compartir",
  "dashboard.copy": "Copiar",
  "dashboard.delete": "Eliminar",
  "dashboard.subjects": "Sujetos",
  "dashboard.criteria": "Criterios",
  "dashboard.progress": "Progreso",
  "dashboard.completed": "Completado",
  "dashboard.created": "Creado:",
  "dashboard.updated": "Actualizado:",
  "dashboard.loadingDashboard": "Cargando panel...",
  "dashboard.retry": "Reintentar",
  "dashboard.title": "Panel de evaluación",
  "dashboard.projectMerge": "Integración de proyecto",
  "dashboard.createNew": "Crear nueva evaluación",
  "dashboard.inProgressTab": "Evaluaciones en progreso",
  "dashboard.completedTab": "Evaluaciones completadas",
  "dashboard.noInProgress": "No hay evaluaciones en progreso",
  "dashboard.noInProgressDesc": "Comencemos creando una nueva evaluación.",
  "dashboard.noCompleted": "No hay evaluaciones completadas",
  "dashboard.noCompletedDesc": "Las evaluaciones completadas aparecerán aquí.",
  "dashboard.untitledProject": "Proyecto de evaluación sin título",
  "dashboard.sharing": "Compartiendo",
  "billing.paymentCompleted": "Pago completado",
  "billing.subscriptionCompleted": "Registro de suscripción completado. ¡Gracias por usar nuestro servicio!",
  "billing.paymentCanceled": "El pago fue cancelado. Por favor intente de nuevo o contáctenos.",
  "settings.backToDashboard": "← Volver al panel",
  "userSettings.title": "Configuración de usuario",
  "userSettings.description": "Gestione la información de su cuenta y configuración de seguridad.",
  "userSettings.basicInfo": "Información básica",
  "userSettings.username": "Nombre de usuario",
  "userSettings.usernamePlaceholder": "Ingrese nombre de usuario",
  "userSettings.email": "Correo electrónico",
  "userSettings.emailPlaceholder": "ejemplo@dominio.com",
  "userSettings.displayName": "Nombre para mostrar",
  "userSettings.displayNamePlaceholder": "Ingrese nombre para mostrar (opcional)",
  "userSettings.displayNameHelp": "Nombre mostrado a otros usuarios.",
  "userSettings.saving": "Guardando...",
  "userSettings.saveSettings": "Guardar configuración",
  "userSettings.securitySettings": "Configuración de seguridad",
  "userSettings.securityMode": "Modo de seguridad",
  "userSettings.securityModeDescription": "Habilitar cifrado de datos para proteger su privacidad.",
  "userSettings.securityOn": "Habilitado",
  "userSettings.securityOff": "Deshabilitado",
  "userSettings.securityCode": "Código de seguridad",
  "userSettings.hide": "Ocultar",
  "userSettings.show": "Mostrar",
  "userSettings.encryptionCode": "Código de cifrado",
  "userSettings.recoveryCode": "Código de recuperación",
  "userSettings.copy": "Copiar",
  "userSettings.generateNewKeys": "Generar nuevas claves",
  "userSettings.manualKeyInput": "Entrada manual de claves",
  "userSettings.viewSharedData": "Ver datos compartidos",
  "userSettings.viewSharedDataDescription": "Ingrese claves para ver datos cifrados compartidos por otros usuarios.",
  "userSettings.inputEncryptionKey": "Ingresar clave de cifrado",
  "userSettings.manualKeyTitle": "Entrada manual de clave de cifrado",
  "userSettings.manualKeyDescription": "Ingrese el par de claves de cifrado compartido.",
  "userSettings.publicKey": "Clave pública",
  "userSettings.publicKeyPlaceholder": "Ingrese clave pública",
  "userSettings.privateKey": "Clave privada",
  "userSettings.privateKeyPlaceholder": "Ingrese clave privada",
  "userSettings.keyWarning": "Advertencia:",
  "userSettings.keyWarningText": "Estas claves son confidenciales. Guárdelas en un lugar seguro.",
  "userSettings.setKeys": "Establecer claves",
  "userSettings.requiredFieldsError": "El nombre de usuario y el correo electrónico son campos obligatorios.",
  "userSettings.enableSecurityModeConfirm": "¿Habilitar modo de seguridad? El cifrado de datos comenzará.",
  "userSettings.securityModeEnabled": "El modo de seguridad ha sido habilitado.",
  "userSettings.securityModeDisabled": "El modo de seguridad ha sido deshabilitado.",
  "userSettings.generateNewKeysConfirm": "¿Generar nuevas claves? Las claves existentes se volverán inválidas.",
  "userSettings.newKeysGenerated": "Se han generado nuevas claves.",
  "userSettings.bothKeysRequired": "Se requieren tanto la clave pública como la privada.",
  "userSettings.invalidPublicKeyFormat": "El formato de la clave pública es inválido.",
  "userSettings.invalidPrivateKeyFormat": "El formato de la clave privada es inválido.",
  "userSettings.keysSet": "Las claves han sido establecidas.",
  "userSettings.keySetError": "Se produjo un error al establecer las claves.",
  "userSettings.copiedToClipboard": "Copiado al portapapeles.",
  "userSettings.copyFailed": "Error al copiar.",
  "billing.currentPlan": "Plan actual",
  "billing.status.developerAccess": "Acceso de desarrollador",
  "billing.status.active": "Activo",
  "billing.status.free": "Gratuito",
  "billing.nextRenewalDate": "Próxima fecha de renovación",
  "billing.autoRenewalNote": "(se cobrará automáticamente)",
  "billing.expiresAt": "Vence el",
  "billing.cancelNotice": "Esta suscripción se cancelará al final del período actual.",
  "billing.cancelSubscription": "Cancelar suscripción",
  "billing.cancelSubscriptionConfirm": "¿Cancelar suscripción? Se cancelará al final del período actual.",
  "billing.cancelSubscriptionSuccess": "La cancelación de la suscripción ha sido procesada. Se cancelará al final del período actual.",
  "billing.cancelSubscriptionFailed": "Error al cancelar.",
  "billing.forIndividual": "(Para individuos)",
  "billing.forBusiness": "(Para empresas)",
  "billing.forSchool": "(Para escuelas)",
  "billing.free": "Gratuito",
  "billing.month": "mes",
  "billing.year": "año",
  "billing.features": "Características",
  "billing.upgrade": "Actualizar",
  "billing.customQuote": "Cotización personalizada",
  "billing.flexibleCustomization": "Soporte de personalización flexible",
  "billing.educationalDiscount": "Precios especiales para instituciones educativas",
  "billing.requestCorporateQuote": "Solicitar cotización corporativa",
  "billing.requestAcademicQuote": "Solicitar cotización académica",
  "billing.aboutBilling": "Acerca de la facturación",
  "billing.autoRenewal": "Renovación automática",
  "billing.autoRenewalDescription": "Los planes mensuales se renuevan automáticamente el mismo día de cada mes",
  "billing.nextRenewalDateDescription": "Los suscriptores actuales pueden verificar en la sección \"Plan actual\" arriba",
  "billing.cancellation": "Cancelación",
  "billing.cancellationDescription": "Se puede cancelar en cualquier momento, el servicio terminará al final del período actual",
  "billing.payment": "Pago",
  "billing.paymentDescription": "Utilizamos el sistema de pago seguro de Stripe",
  "billing.receipt": "Recibo",
  "billing.receiptDescription": "Se envía automáticamente por correo después de completar el pago",
  "billing.aiUsageLimitation": "Aviso de limitación de uso de IA",
  "billing.enterprise": "Para Empresas",
  "billing.education": "Para Educación",
  "billing.feature.limited_projects": "Hasta 3 proyectos",
  "billing.feature.unlimited_projects": "Proyectos ilimitados",
  "billing.feature.unlimited_collaborators": "Colaboradores ilimitados",
  "billing.feature.basic_rubric": "Funciones básicas de rúbrica",
  "billing.feature.advanced_rubric": "Funciones avanzadas de rúbrica",
  "billing.feature.ai_assistance": "Funciones de asistencia IA",
  "billing.feature.priority_support": "Soporte prioritario",
  "billing.feature.data_export": "Exportación de datos",
  "billing.feature.custom_templates": "Plantillas personalizadas",
  "billing.feature.pdf_export": "Exportación a PDF",
  "billing.feature.limited_pdf_export": "Exportación a PDF (5 por día)",
  "billing.feature.no_csv_export": "Exportación a CSV: No disponible",
  "billing.feature.allProfessionalFeatures": "Todas las funciones del Plan Profesional",
  "billing.feature.unlimitedUsers": "Número ilimitado de usuarios",
  "billing.feature.dedicatedSupportAgent": "Agente de soporte dedicado",
  "billing.feature.customIntegrationAPI": "Integración personalizada y desarrollo de API",
  "billing.feature.customBranding": "Soporte de marca personalizada",
  "billing.feature.singleSignOn": "Single Sign-On (SSO)",
  "billing.feature.auditLogSecurity": "Registro de auditoría y funciones de seguridad",
  "billing.feature.onPremiseDeployment": "Soporte de implementación local",
  "billing.feature.trainingImplementationSupport": "Soporte de capacitación e implementación",
  "billing.feature.unlimitedStudentFacultyAccounts": "Cuentas ilimitadas para estudiantes y profesores",
  "billing.feature.educationalInstitutionSpecialPricing": "Precios especiales para instituciones educativas",
  "billing.feature.classroomPracticalTemplates": "Plantillas prácticas para el aula",
  "billing.feature.gradeManagementSystemIntegration": "Integración con sistema de gestión de calificaciones",
  "billing.feature.learningAnalyticsReporting": "Análisis de aprendizaje e informes",
  "billing.feature.parentGuardianSharingFeature": "Función para compartir con padres y tutores",
  "billing.feature.educationalInstitutionDedicatedSupport": "Soporte dedicado para instituciones educativas",
  "billing.feature.implementationTrainingTeacherTraining": "Capacitación de implementación y formación docente",
  "quote.title": "Solicitud de Cotización Plan Empresarial",
  "quote.submit": "Solicitar Cotización",
  "quote.sections.contactInfo": "Información de Contacto",
  "quote.sections.usagePlan": "Plan de Uso",
  "quote.sections.budgetRequirements": "Presupuesto y Requisitos",
  "quote.fields.name": "Nombre",
  "quote.fields.position": "Cargo",
  "quote.fields.phone": "Número de Teléfono",
  "quote.fields.expectedUsers": "Número Esperado de Usuarios",
  "quote.fields.timeline": "Cronograma de Implementación",
  "quote.fields.useCase": "Caso de Uso",
  "quote.fields.currentSolution": "Método/Herramienta de Evaluación Actual",
  "quote.fields.budget": "Rango de Presupuesto",
  "quote.fields.requirements": "Funciones/Requisitos Necesarios",
  "quote.fields.message": "Solicitudes/Preguntas Adicionales",
  "quote.placeholders.currentSolution": "Por favor describa los métodos o herramientas de evaluación actuales que está utilizando",
  "quote.placeholders.message": "Por favor háganos saber si tiene solicitudes o preguntas adicionales",
  "quote.timeline.immediate": "Inmediatamente",
  "quote.timeline.oneMonth": "Dentro de 1 mes",
  "quote.timeline.threeMonths": "Dentro de 3 meses",
  "quote.timeline.sixMonths": "Dentro de 6 meses",
  "quote.timeline.oneYear": "Dentro de 1 año",
  "quote.timeline.undecided": "Indeciso",
  "quote.success.title": "Solicitud de cotización recibida",
  "quote.error.submitFailed": "Error al enviar la solicitud de cotización",
  "quote.error.submitFailedRetry": "Error al enviar la solicitud de cotización. Por favor inténtelo de nuevo más tarde.",
  "common.pleaseSelect": "Por favor seleccione",
  "common.other": "Otro",
  "common.submitting": "Enviando...",
  "quote.corporate.subtitle": "Para Empresas",
  "quote.corporate.description": "Ofrecemos soluciones empresariales personalizables adaptadas a las necesidades de su empresa. Complete el formulario a continuación y siéntase libre de contactarnos.",
  "quote.corporate.sections.companyInfo": "Información de la Empresa",
  "quote.corporate.fields.companyName": "Nombre de la Empresa",
  "quote.corporate.fields.department": "Departamento",
  "quote.corporate.userCounts.small": "10-50 usuarios",
  "quote.corporate.userCounts.medium": "51-100 usuarios",
  "quote.corporate.userCounts.large": "101-300 usuarios",
  "quote.corporate.userCounts.xlarge": "301-500 usuarios",
  "quote.corporate.userCounts.xxlarge": "501-1,000 usuarios",
  "quote.corporate.userCounts.enterprise": "1,000+ usuarios",
  "quote.corporate.budget.under500k": "Menos de €5,000/mes",
  "quote.corporate.budget.500k1m": "€5,000-€10,000/mes",
  "quote.corporate.budget.1m3m": "€10,000-€30,000/mes",
  "quote.corporate.budget.3m5m": "€30,000-€50,000/mes",
  "quote.corporate.budget.over5m": "Más de €50,000/mes",
  "quote.corporate.placeholders.useCase": "ej.: sistema de evaluación interno, evaluación de entrevistas de contratación, medición de efectividad de capacitación",
  "quote.corporate.formNote": "La información que proporcione será gestionada apropiadamente de acuerdo con nuestra política de privacidad.",
  "quote.success.corporate.message": "Gracias por su solicitud. Nuestro representante se pondrá en contacto con usted dentro de 2 días hábiles.",
  "quote.corporate.requirements.sso": "Single Sign-On (SSO)",
  "quote.corporate.requirements.activeDirectory": "Integración Active Directory",
  "quote.corporate.requirements.customBranding": "Marca Personalizada",
  "quote.corporate.requirements.dedicatedServer": "Servidor Dedicado/Implementación Local",
  "quote.corporate.requirements.apiIntegration": "Integración API/Integración Personalizada",
  "quote.corporate.requirements.auditLogs": "Registros de Auditoría/Funciones de Seguridad",
  "quote.corporate.requirements.multilingual": "Soporte Multi-idioma",
  "quote.corporate.requirements.support24": "Soporte 24/7",
  "quote.corporate.requirements.training": "Capacitación de Implementación",
  "quote.corporate.requirements.dataMigration": "Soporte de Migración de Datos",
  "quote.academic.subtitle": "Para Escuelas e Instituciones Educativas",
  "quote.academic.description": "Ofrecemos soluciones especialmente diseñadas para instituciones educativas. Precios especiales y personalizaciones de funciones específicas para educación están disponibles.",
  "quote.academic.sections.institutionInfo": "Información de la Institución Educativa",
  "quote.academic.fields.institutionName": "Nombre de la Escuela/Institución",
  "quote.academic.fields.institutionType": "Tipo de Institución",
  "quote.academic.fields.department": "Facultad/Departamento",
  "quote.academic.fields.positionTitle": "Cargo/Título",
  "quote.academic.fields.expectedUsers": "Número Esperado de Usuarios (Profesores/Personal)",
  "quote.academic.fields.studentCount": "Número de Estudiantes",
  "quote.academic.fields.currentSolution": "Método/Sistema de Evaluación Actual",
  "quote.academic.fields.budgetAnnual": "Rango de Presupuesto (Anual)",
  "quote.academic.institutionTypes.university": "Universidad",
  "quote.academic.institutionTypes.college": "Instituto/Instituto Comunitario",
  "quote.academic.institutionTypes.highSchool": "Escuela Secundaria",
  "quote.academic.institutionTypes.juniorHigh": "Escuela Media",
  "quote.academic.institutionTypes.elementary": "Escuela Primaria",
  "quote.academic.institutionTypes.vocational": "Escuela de Formación Profesional",
  "quote.academic.userCounts.small": "5-20 usuarios",
  "quote.academic.userCounts.medium": "21-50 usuarios",
  "quote.academic.userCounts.large": "51-100 usuarios",
  "quote.academic.userCounts.xlarge": "101-300 usuarios",
  "quote.academic.userCounts.xxlarge": "301-500 usuarios",
  "quote.academic.userCounts.enterprise": "500+ usuarios",
  "quote.academic.studentCounts.under100": "Menos de 100",
  "quote.academic.studentCounts.small": "100-500",
  "quote.academic.studentCounts.medium": "501-1,000",
  "quote.academic.studentCounts.large": "1,001-3,000",
  "quote.academic.studentCounts.xlarge": "3,001-10,000",
  "quote.academic.studentCounts.xxlarge": "10,000+",
  "quote.academic.timeline.nextSemester": "Próximo Semestre",
  "quote.academic.timeline.nextYear": "Próximo Año Académico",
  "quote.academic.budget.under1m": "Menos de €10,000",
  "quote.academic.budget.1m3m": "€10,000-€30,000",
  "quote.academic.budget.3m5m": "€30,000-€50,000",
  "quote.academic.budget.5m10m": "€50,000-€100,000",
  "quote.academic.budget.over10m": "€100,000+",
  "quote.academic.placeholders.position": "ej.: Profesor, Profesor Asistente, Personal Administrativo",
  "quote.academic.placeholders.useCase": "ej.: evaluación de estudiantes, evaluación práctica/habilidades, capacitación del personal, evaluación del curso",
  "quote.academic.placeholders.currentSolution": "Por favor describa los métodos o sistemas de evaluación actuales que está utilizando",
  "quote.academic.placeholders.message": "Por favor háganos saber si tiene requisitos específicos de instituciones educativas o preguntas",
  "quote.academic.formNote": "La información que proporcione será gestionada apropiadamente de acuerdo con nuestra política de privacidad.",
  "quote.success.academic.message": "Gracias por su solicitud. Nuestro especialista en instituciones educativas se pondrá en contacto con usted dentro de 2 días hábiles.",
  "quote.academic.requirements.lmsIntegration": "Integración Sistema de Gestión de Aprendizaje (LMS)",
  "quote.academic.requirements.gradeManagement": "Integración Sistema de Gestión de Calificaciones",
  "quote.academic.requirements.studentPortal": "Integración Portal Estudiantil",
  "quote.academic.requirements.parentSharing": "Funciones de Compartir Padres/Tutores",
  "quote.academic.requirements.courseTemplates": "Plantillas de Curso/Prácticas",
  "quote.academic.requirements.learningAnalytics": "Análisis de Aprendizaje/Informes",
  "quote.academic.requirements.multilingualEng": "Soporte Multi-idioma (Inglés, etc.)",
  "quote.academic.requirements.teacherTraining": "Capacitación de Profesores",
  "quote.academic.requirements.implementationSupport": "Soporte de Implementación/Capacitación",
  "common.backToDashboard": "Volver al Panel",

  // Report Generation
  "report.title": "Generación de Informes",
  "report.evaluationNotice": "Informe de Evaluación",
  "report.evaluationDate": "Fecha de Evaluación",
  "report.criteriaEvaluation": "Evaluación por Criterios",
  "report.overallEvaluation": "Evaluación General",
  "report.comments": "Comentarios",
  "report.commentsPlaceholder": "Ingrese detalles o comentarios...",
  "report.commentsEmpty": "No se han ingresado detalles",
  "report.editComments": "Editar Detalles",
  "report.showPreview": "Mostrar Vista Previa",
  "report.hidePreview": "Ocultar Vista Previa",
  "report.preview": "Vista Previa",
  "report.criterionColumn": "Criterio",
  "report.gradeColumn": "Calificación",
  "report.rankColumn": "Rango",
  "report.descriptionColumn": "Descripción",
  "report.nthGrade": "Grado {{grade}}",
  "report.topPercentile": "Top {{percent}}%",
  "report.rankFormat": "{{position}}/{{total}}",
  "report.noDescription": "-",
  "report.personalEvaluation": "Evaluación Personal",
  "report.groupAverage": "Promedio del Grupo",
  "report.summary": "Resumen",
  "report.enableOverallEvaluation": "Habilitar Evaluación General",
  "report.disableOverallEvaluation": "Deshabilitar Evaluación General",
  "report.pointsFormat": "{{score}} puntos / {{maxScore}} puntos",
  "report.percentageFormat": "({{percentage}}%)",
  "report.configureWeights": "Configurar Ponderaciones",
  "report.footerNote": "※ Esta evaluación muestra tanto evaluaciones basadas en criterios como normativas.",
  "report.rubricTitle": "Criterios de Evaluación (Rúbrica)",
  "report.noRubric": "No se ha generado ninguna rúbrica",
  "report.noSubjects": "No se han registrado temas de evaluación.",
  "report.print": "Imprimir",
  "report.downloadPdf": "Descargar PDF",
  "report.downloadPdfLimitReached": "Descargar PDF (Límite Alcanzado)",
  "report.pdfExportLimit": "Límite de exportación PDF ({{count}} archivos por día) alcanzado. Por favor actualice a {{planName}} o inténtelo mañana.",
  "report.pdfExportError": "La exportación PDF no está disponible.",
  "report.pdfGenerationFailed": "La generación de PDF falló.",
  "report.pdfGenerationError": "Error de generación de PDF:",
  "report.reportCardNotFound": "Boleta de calificaciones no encontrada.",
  "report.pdfExportStatus": "Exportaciones PDF de hoy: {{current}}/{{max}}",
  "report.pdfExportRemaining": " ({{remaining}} restantes)",
  "report.pdfExportLimitReached": "Límite de exportación diaria alcanzado. {{planName}} ofrece exportaciones ilimitadas.",
  "report.backToRubric": "Volver a Generación de Rúbrica",
  "autoSave.unsaved": "Sin guardar",
  "autoSave.savedSecondsAgo": "Guardado hace {{seconds}} segundos",
  "autoSave.savedMinutesAgo": "Guardado hace {{minutes}} minutos",
  "autoSave.savedAtTime": "Guardado a las {{time}}",
  "autoSave.saving": "Guardando...",
  "autoSave.unsavedChanges": "Cambios sin guardar",
  "autoSave.autoSaveOn": "Guardado automático: ACTIVADO",
  "plan.pro": "PRO",
  "billing.businessPrice": "$25~",
  "billing.schoolPrice": "$7~",
  "billing.pricePerMonth": "/mes/persona",

  // Steps
  "steps.process.ariaLabel": "Proceso de evaluación",
  "steps.productRegistration.title": "Registrar sujetos",
  "steps.productRegistration.description": "Registrar sujetos a evaluar",
  "steps.criteriaExtraction.title": "Extraer criterios",
  "steps.criteriaExtraction.description": "Extraer criterios de evaluación con IA",
  "steps.comparison.title": "Evaluación comparativa",
  "steps.comparison.description": "Posicionar relativamente",
  "steps.gradeAssignment.title": "Asignación de calificaciones",
  "steps.gradeAssignment.description": "Determinar calificaciones finales",
  "steps.rubricGeneration.title": "Generar rúbrica",
  "steps.rubricGeneration.description": "Crear rúbrica con IA",
  "steps.quickEvaluation.title": "Evaluación rápida",
  "steps.quickEvaluation.description": "Completar evaluación fácilmente",
  "steps.reportGeneration.title": "Generar informes",
  "steps.reportGeneration.description": "Crear hermosas boletas",

  // Criteria Extraction
  "criteriaExtraction.emptyState.title": "Por favor, registre primero los sujetos de evaluación",
  "criteriaExtraction.emptyState.description": "Para extraer criterios, primero debe registrar los sujetos de evaluación.",
  "criteriaExtraction.emptyState.backButton": "Volver al registro de sujetos",
  "criteriaExtraction.title": "Extracción de criterios",
  "criteriaExtraction.description": "Describa qué criterios desea evaluar. La IA extraerá automáticamente los criterios de evaluación.",
  "criteriaExtraction.policyTitle": "Política de evaluación y puntos clave",
  "criteriaExtraction.policyDescription": "Describa específicamente qué criterios desea evaluar. La IA extraerá automáticamente los criterios de evaluación óptimos.",
  "criteriaExtraction.policyLabel": "Política de evaluación",
  "criteriaExtraction.policyPlaceholder": "Ejemplo: Enfatizar la estructura lógica, evaluar la creatividad y originalidad, enfocarse en la viabilidad, etc.",
  "criteriaExtraction.removePolicyTitle": "Eliminar política de evaluación {{index}}",
  "criteriaExtraction.addPolicyButton": "Agregar política de evaluación",
  "criteriaExtraction.extractButton": "Extraer con IA",
  "criteriaExtraction.extractingButton": "Extrayendo con IA...",
  "criteriaExtraction.extractedTitle": "Criterios de evaluación extraídos",
  "criteriaExtraction.extractedSubtitle": "Se han extraído {{count}} criterios de evaluación. Por favor, revise y edite el contenido.",
  "criteriaExtraction.addCriterionButton": "Agregar criterio manualmente",
  "criteriaExtraction.newCriterionTitle": "Nuevo criterio",
  "criteriaExtraction.newCriterionDescription": "Evaluar basándose en este criterio",
  "criteriaExtraction.successTitle": "¡Extracción de criterios completada!",
  "criteriaExtraction.successDescription": "Revise cada criterio y edítelo según sea necesario antes de continuar con el siguiente paso.",
  "criteriaExtraction.nextButton": "A la evaluación comparativa",
  "criteriaExtraction.prevButton": "Volver al registro de sujetos",

  // Product Registration
  "productRegistration.title": "Registrar sujetos de evaluación",
  "productRegistration.description": "Registre los sujetos a evaluar (informes de estudiantes, productos, propuestas, etc.).",
  "productRegistration.securityNotice": "🔒 El modo de seguridad está activado. Los nombres de los sujetos serán encriptados.",
  "productRegistration.viewToggle.form": "Formulario",
  "productRegistration.viewToggle.formTitle": "Vista de formulario",
  "productRegistration.viewToggle.table": "Tabla",
  "productRegistration.viewToggle.tableTitle": "Vista de tabla",
  "productRegistration.import.drive": "Importar desde Google Drive",
  "productRegistration.import.driveTitle": "Importar desde Google Drive",
  "productRegistration.import.driveLabel": "Importar archivos desde Google Drive",
  "productRegistration.import.csv": "Cargar archivo CSV",
  "productRegistration.import.csvTitle": "Cargar archivo CSV",
  "productRegistration.import.csvLabel": "Cargar sujetos de evaluación desde archivo CSV",
  "productRegistration.import.template": "Descargar plantilla CSV",
  "productRegistration.import.templateTitle": "Descargar plantilla CSV",
  "productRegistration.import.templateLabel": "Descargar archivo de plantilla CSV",
  "productRegistration.import.driveDetail": "Importado desde Google Drive: {{fileName}}",
  "productRegistration.form.titleLabel": "Nombre del sujeto",
  "productRegistration.form.titlePlaceholder": "ej. Informe A, Propuesta B, Proyecto C",
  "productRegistration.form.titleHelp": "Ingrese el nombre del sujeto a evaluar",
  "productRegistration.form.linkLabel": "Enlace (Opcional)",
  "productRegistration.form.linkPlaceholder": "https://drive.google.com/... etc.",
  "productRegistration.form.linkHelp": "Ingrese la URL de materiales o archivos relacionados si están disponibles",
  "productRegistration.form.detailLabel": "Detalles y comentarios",
  "productRegistration.form.detailPlaceholder": "Ingrese los detalles necesarios para la evaluación, como características, contenido e información de contexto.\nEjemplo: \"Versión borrador de tesis de graduación, propuesta de revitalización regional creada por estudiante de 3er año de economía\"",
  "productRegistration.form.detailHelp": "Por favor proporcione detalles específicos sobre el contenido y las características para ayudar a los evaluadores a evaluar adecuadamente",
  "productRegistration.form.addButton": "Agregar sujeto",
  "productRegistration.list.title": "Sujetos registrados ({{count}})",
  "productRegistration.list.encryptedBadge": "🔒 Encriptado",
  "productRegistration.list.encrypted": "Encriptado",
  "productRegistration.edit.titlePlaceholder": "Ingrese el nombre del sujeto",
  "productRegistration.edit.linkPlaceholder": "Ingrese la URL del enlace",
  "productRegistration.edit.detailPlaceholder": "Ingrese detalles y comentarios",
  "productRegistration.edit.save": "Guardar",
  "productRegistration.edit.cancel": "Cancelar",
  "productRegistration.preview": "Vista previa de {{title}}",
  "productRegistration.edit": "Editar {{title}}",
  "productRegistration.delete": "Eliminar {{title}}",
  "productRegistration.googleDrive.importedDetail": "Importado desde Google Drive: {{name}}",
  "productRegistration.csv.header1": "Nombre del sujeto",
  "productRegistration.csv.detail1": "Descripción detallada",
  "productRegistration.csv.validationError": "El archivo CSV debe tener las columnas reviewTitle y reviewComment. Por favor descargue la plantilla y verifique.",
  "productRegistration.error.encryptionFailed": "Fallo al encriptar el nombre del sujeto. Por favor verifique la configuración de seguridad.",
  "productRegistration.navigation.next": "A la extracción de criterios",
  "productRegistration.directRubric.title": "Crear rúbrica directamente",
  "productRegistration.directRubric.description": "También puede omitir la extracción de criterios y crear una rúbrica manualmente.",
  "productRegistration.directRubric.button": "Ir a la creación manual de rúbrica",
  "productRegistration.nextButton": "A la extracción de criterios",
  "productRegistration.error.decryptionLog": "Error de descifrado para el sujeto {{index}}:",
  "productRegistration.error.decryptionDisplay": "[Error de descifrado]",
  "productRegistration.error.encryptionLog": "Error de encriptación del nombre del sujeto:",
  "productRegistration.error.encryptionAlert": "Fallo al encriptar el nombre del sujeto. Por favor verifique la configuración de seguridad.",
  "productRegistration.error.csvAlert": "El archivo CSV debe tener las columnas reviewTitle y reviewComment. Por favor descargue la plantilla y verifique.",
  "productRegistration.csv.exampleTitle1": "Nombre del sujeto 1",
  "productRegistration.csv.exampleDetail1": "Descripción detallada 1",
  "productRegistration.csv.exampleTitle2": "Nombre del sujeto 2",
  "productRegistration.csv.exampleDetail2": "Descripción detallada 2",
  "productRegistration.csv.exampleTitle3": "Nombre del sujeto 3",
  "productRegistration.csv.exampleDetail3": "Descripción detallada 3",

  // Comparison Evaluation
  "comparisonEvaluation.emptyState.title": "Por favor, establezca primero los sujetos de evaluación y los criterios",
  "comparisonEvaluation.emptyState.description": "Se requieren tanto sujetos de evaluación como criterios para la evaluación comparativa.",
  "comparisonEvaluation.emptyState.backToProducts": "Volver al registro de sujetos",
  "comparisonEvaluation.emptyState.backToCriteria": "Volver a la extracción de criterios",
  "comparisonEvaluation.title": "Ordenemos algunos por calidad",
  "comparisonEvaluation.description": "",
  "comparisonEvaluation.criterionSelector.title": "Seleccionar criterio de evaluación",
  "comparisonEvaluation.productsPanel.title": "Sujetos de evaluación",
  "comparisonEvaluation.productsPanel.hint": "Arrastre para posicionar en la línea numérica",
  "comparisonEvaluation.evaluationLine.low": "Malo",
  "comparisonEvaluation.evaluationLine.high": "Bueno",
  "comparisonEvaluation.evaluationLine.hint": "Puede arrastrar y reposicionar los elementos colocados",
  "comparisonEvaluation.progress.prefix": "Progreso: ",
  "comparisonEvaluation.progress.suffix": " / {{total}} colocados",
  "comparisonEvaluation.progress.completed": "✅ Todas las evaluaciones completadas",
  "comparisonEvaluation.options.title": "Seleccionar método de colocación",
  "comparisonEvaluation.options.description": "Puede elegir colocar todos los elementos a la vez o usar el modo rápido para colocarlos uno por uno después de crear la rúbrica.",
  "comparisonEvaluation.options.quickModeButton": "Usar modo de evaluación rápida",
  "comparisonEvaluation.options.quickModeNote": "※ Modo simple para colocar uno por uno después de crear la rúbrica",
  "comparisonEvaluation.nextButton": "A la asignación de calificaciones",
  "comparisonEvaluation.prevButton": "Volver a la extracción de criterios",

  // Grade Assignment
  "gradeAssignment.emptyState.title": "Por favor complete la evaluación",
  "gradeAssignment.emptyState.description": "La evaluación comparativa debe completarse para establecer las calificaciones.",
  "gradeAssignment.emptyState.backButton": "Volver a la evaluación comparativa",
  "gradeAssignment.title": "Asignación de calificaciones",
  "gradeAssignment.description": "Para cada criterio, arrastre los límites de calificación para ajustarlos.",
  "gradeAssignment.criterionSelector.title": "Seleccionar criterio",
  "gradeAssignment.gradeSuffix": "calificaciones",
  "gradeAssignment.gradeSettings.titleSuffix": " Configuración de calificaciones",
  "gradeAssignment.editGradesButton": "Editar calificaciones",
  "gradeAssignment.boundaries.title": "Ajuste de límites de calificación",
  "gradeAssignment.boundaries.description": "Arrastre las líneas de límite para ajustar los rangos de calificación",
  "gradeAssignment.distribution.title": "Distribución de calificaciones",
  "gradeAssignment.table.grade": "Calificación",
  "gradeAssignment.table.count": "Cantidad",
  "gradeAssignment.table.percentage": "Porcentaje",
  "gradeAssignment.table.subjects": "Sujetos de evaluación",
  "gradeAssignment.table.tooltip": "Doble clic para mostrar detalles",
  "gradeAssignment.nextButton": "A la generación de rúbrica",
  "gradeAssignment.prevButton": "Volver a la evaluación comparativa",
  "gradeAssignment.modal.title": "Editar calificaciones",
  "gradeAssignment.modal.gradeNamesTitle": "Establecer nombres de calificaciones",
  "gradeAssignment.modal.gradeLabel": "Calificación {{index}}",
  "gradeAssignment.modal.deleteButton": "Eliminar",
  "gradeAssignment.modal.addGradeButton": "Agregar calificación",
  "gradeAssignment.modal.doneButton": "Listo",
  "gradeAssignment.status.notEvaluated": "No evaluado",
  "gradeAssignment.status.notSet": "No establecido",
  "gradeAssignment.saveSuccess": "¡Datos de evaluación guardados!",
  "rubricGeneration.emptyState.title": "Por favor complete la asignación de calificaciones",
  "rubricGeneration.emptyState.description": "La asignación de calificaciones debe completarse antes de generar rúbricas.",
  "rubricGeneration.emptyState.backButton": "Volver a Asignación de Calificaciones",
  "rubricGeneration.title": "Generación de Rúbricas",
  "rubricGeneration.description": "Cree rúbricas detalladas analizando las diferencias entre los trabajos mejor calificados.",
  "rubricGeneration.progress.title": "Progreso del Análisis de Diferencias de Límites de Calificación",
  "rubricGeneration.progress.criteriaComplete": "criterios completados",
  "rubricGeneration.progress.boundaryComplete": "límites completados",
  "rubricGeneration.question.criterionLabel": "Criterio:",
  "rubricGeneration.question.gradeSuffix": "Calificación",
  "rubricGeneration.question.moreCount": "+{{count}} más",
  "rubricGeneration.question.title": "¿Qué diferencias notó entre los trabajos de Calificación {{upperGrade}} y Calificación {{lowerGrade}} para el criterio \"{{criterion}}\"?",
  "rubricGeneration.question.placeholder": "Ejemplo: Los trabajos de Calificación {{upperGrade}} tienen una estructura lógica clara con abundantes datos de apoyo. Los trabajos de Calificación {{lowerGrade}} tienen buenos argumentos pero carecen de ejemplos específicos y poder persuasivo.",
  "rubricGeneration.question.addButton": "Agregar Diferencia",
  "rubricGeneration.question.recordedDifferences": "Diferencias Registradas:",
  "rubricGeneration.question.deleteButton": "Eliminar",
  "rubricGeneration.question.completeButton": "Completar Este Análisis de Límite",
  "rubricGeneration.summary.title": "Resumen del Análisis de Límites de Calificación",
  "rubricGeneration.summary.boundaryTitle": "Límite {{upperGrade}}-{{lowerGrade}}",
  "rubricGeneration.summary.differencesCount": "{{count}} diferencias registradas",
  "rubricGeneration.generation.generating": "Generando rúbrica...",
  "rubricGeneration.generation.generateButton": "Generar Rúbrica IA",
  "rubricGeneration.display.title": "Rúbrica Generada",
  "rubricGeneration.display.description": "Rúbrica detallada creada a partir de información de diferencias analizada por IA.",
  "rubricGeneration.display.regenerateButton": "Regenerar",
  "rubricGeneration.navigation.nextToQuick": "A Evaluación Rápida",
  "rubricGeneration.navigation.backToGrade": "Volver a Asignación de Calificaciones",
  "rubricGeneration.error.generation": "Se produjo un error al generar la rúbrica",

  // Progress Bar
  "progressBar.label": "Progreso de evaluación",
  "progressBar.messages.criteriaSetup": "Establecer criterios completará el 15%",
  "progressBar.messages.completed": "🎉 ¡Evaluación completada!",
  "progressBar.messages.progress": "Productos: {{products}} × Criterios: {{criteria}} = {{total}} evaluaciones",

  // Evaluation Header
  "evaluationHeader.placeholder": "Ingrese el título de evaluación",
  "evaluationHeader.saveTitle": "Guardar",
  "evaluationHeader.cancelTitle": "Cancelar",
  "evaluationHeader.untitled": "Evaluación sin título",
  "evaluationHeader.editTitle": "Editar título",

  // Draggable Product Card
  "draggableProductCard.detailsCount": "Detalles: {{count}} caracteres",
  "draggableProductCard.previewAvailable": "🔗 Vista previa disponible",
  "draggableProductCard.showPreview": "Mostrar vista previa",
  "draggableProductCard.editDetails": "Editar detalles",
  "draggableProductCard.position": "Posición: {{value}}",
  "draggableProductCard.rank": "Rango: {{value}}",
  "draggableProductCard.placed": "Colocado",

  // Comparative Evaluation Quick
  "comparativeEvaluationQuick.title": "Modo de evaluación rápida",
  "comparativeEvaluationQuick.criterionSelector.title": "Seleccionar criterio de evaluación",
  "comparativeEvaluationQuick.productsPanel.title": "Elementos de evaluación",
  "comparativeEvaluationQuick.productsPanel.currentlyEvaluating": "Evaluando actualmente:",
  "comparativeEvaluationQuick.nextButton": "Siguiente",
  "comparativeEvaluationQuick.prevButton": "Atrás",
  "comparativeEvaluationQuick.grades.excellent": "Excelente",
  "comparativeEvaluationQuick.grades.good": "Bueno",
  "comparativeEvaluationQuick.grades.average": "Promedio",
  "comparativeEvaluationQuick.grades.needsImprovement": "Necesita mejorar",
  "comparativeEvaluationQuick.completion.title": "Evaluación completada",
  "comparativeEvaluationQuick.completion.subtitle": "Se han evaluado los {{count}} elementos",
  "comparativeEvaluationQuick.completion.evaluationCount": "Elementos evaluados",
  "comparativeEvaluationQuick.completion.criteriaCount": "Criterios de evaluación",
  "comparativeEvaluationQuick.completion.viewResults": "Ver resultados",
  "comparativeEvaluationQuick.completion.detailAdjustment": "Ajuste detallado",
  "comparativeEvaluationQuick.criterionComplete.title": "\"{{criterion}}\" completado",
  "comparativeEvaluationQuick.criterionComplete.subtitle": "{{count}} elementos evaluados",
  "comparativeEvaluationQuick.criterionComplete.nextCriterion": "Siguiente criterio: ",
  "comparativeEvaluationQuick.criterionComplete.proceedToNext": "Proceder al siguiente criterio",
  "comparativeEvaluationQuick.criterionComplete.allComplete": "Todas las evaluaciones de criterios están completas",
  "comparativeEvaluationQuick.criterionComplete.viewResults": "Ver resultados",
  "comparativeEvaluationQuick.empty.title": "No hay datos para evaluar",
  "comparativeEvaluationQuick.empty.description": "Configure productos y criterios de evaluación.",
  "comparativeEvaluationQuick.header.doubleClickToView": "Doble clic para ver detalles",
  "comparativeEvaluationQuick.header.progress": "{{completed}} / {{total}} completados",
  "comparativeEvaluationQuick.header.criterionProgress": "({{current}} / {{total}} criterios)",
  "comparativeEvaluationQuick.navigation.nextCriterion": "Siguiente criterio: {{name}}",
  "comparativeEvaluationQuick.progress.remaining": "{{count}} restantes",
  "comparativeEvaluationQuick.gradeExplanation.instruction": "Haga clic en cualquier lugar desde la izquierda (D: Necesita mejorar) hasta la derecha (A: Excelente) para colocar su evaluación.",
  "comparativeEvaluationQuick.gradeExplanation.currentPosition": " Posición actual: {{grade}} ({{description}})",
  "comparativeEvaluationQuick.actions.switchToAllMode": "Cambiar al modo de colocación completa",
  "comparativeEvaluationQuick.shortcuts.enterNext": "Presione Enter para continuar al siguiente criterio",
  "comparativeEvaluationQuick.shortcuts.spaceSkip": "Presione Espacio para saltar al siguiente criterio",
  "comparativeEvaluationQuick.criterion.instruction": "Juzgue la superioridad según este criterio",

  // Grade Assignment
  "gradeAssignment.modal.gradePlaceholder": "Ingrese el nombre de la calificación",
  "gradeAssignment.boundaryLabel": "Límite {{upper}}・{{lower}}",
  "gradeAssignment.doubleClickToView": "Doble clic para ver detalles",
  "gradeAssignment.dragBoundaryHint": "Arrastre los límites para ajustar los rangos de calificación",
  "gradeAssignment.percentAbove": "{{percent}}% o más es {{grade}}",
  "gradeAssignment.gradeNumber": "Calificación {{number}}",
  "gradeAssignment.grade": "Calificación",

  // Evaluation Page
  "evaluation.noDataToSave": "No hay datos para guardar",
  "evaluation.dataSaved": "¡Datos guardados exitosamente!",
  "evaluation.saveFailed": "Error al guardar",
  "evaluation.saveError": "Se produjo un error al guardar",
  "evaluation.failedKeyword": "Fallido",
  "evaluation.errorKeyword": "Error",
  "evaluation.saving": "💾 Guardando...",

  // Product Registration
  "productRegistration.registeredItems": "Objetos de evaluación registrados ({{count}})",
  "productRegistration.encryptedBadge": "🔒 Cifrado",
  "productRegistration.encryptedTitle": "Cifrado",
  "productRegistration.previewTitle": "Vista previa de {{title}}",
  "productRegistration.editTitle": "Editar {{title}}",
  "productRegistration.deleteTitle": "Eliminar {{title}}",

  // CSV Export
  "csvExport.export": "Exportar CSV",
  
  // Missing translations
  "evaluation.loadError": "Error al cargar el proyecto",
  "evaluation.loadingProject": "Cargando proyecto...",
  
  // Invitation page
  "invitation.invalidOrExpired": "Invitación inválida o expirada",
  "invitation.invalidTitle": "Invitación inválida",
  "invitation.invalidDescription": "Este enlace de invitación es inválido.",
  "invitation.backToDashboard": "Volver al panel",
  "invitation.acceptedTitle": "Invitación aceptada",
  "invitation.acceptedDescription": "Te has unido a la colaboración con éxito.",
  "invitation.redirecting": "Redirigiendo al panel...",
  "invitation.goToDashboard": "Ir al panel",
  "invitation.description": "Has recibido una invitación de colaboración para un proyecto.",
  "invitation.acceptQuestion": "¿Deseas aceptar esta invitación?",
  "invitation.processing": "Procesando...",
  "invitation.decline": "Rechazar",
  "invitation.capabilitiesTitle": "Permisos del colaborador",
  "invitation.capability1": "Ver y editar proyectos",
  "invitation.capability2": "Realizar y modificar evaluaciones",
  "invitation.capability3": "Generar y exportar informes",
  "invitation.capability4": "Invitar a otros miembros",
  "invitation.capability5": "Cambiar la configuración del proyecto",
  
  // RubricGeneration
  "rubricGeneration.generation.generatingDescription": "Analizando criterios y productos para generar la rúbrica de evaluación óptima...",
  "rubricGeneration.generation.step1": "Analizando criterios de evaluación",
  "rubricGeneration.generation.step2": "Analizando características del producto",
  "rubricGeneration.generation.step3": "Generando rúbrica de evaluación",
  "rubricGeneration.criterionSelector.title": "Seleccionar criterios",
  "rubricGeneration.display.editCellAria": "Editar celda",
  
  // Report
  "report.noRubricDescriptions": "No hay descripciones de rúbrica disponibles",
  "report.commentGenerationFailed": "Error al generar comentario",
  "report.allEvaluations": "Todas las evaluaciones",
  "preview.openInNewTab": "Abrir en nueva pestaña",
  "report.generateComment": "Generar comentario",
  "report.pdfGeneration.generating": "Generando PDF",
  "report.pdfGeneration.generatingDescription": "Creando informes PDF para todos los productos...",
  "report.pdfGeneration.step1": "Recopilando datos de evaluación",
  "report.pdfGeneration.step2": "Generando diseño PDF",
  "report.pdfGeneration.step3": "Finalizando informe",
  "report.generatingPdf": "Generando PDF...",
  "report.downloadAllPdf": "Descargar todos los PDFs",
  "report.backToQuick": "Volver a evaluación rápida",
  "report.generatingPdfDescription": "Generando informe PDF. Esto puede tardar un momento...",
  "report.pdfStep1": "Recopilando datos de evaluación",
  "report.pdfStep2": "Creando diseño PDF",
  "report.pdfStep3": "Finalizando informe",
  
  // Product Registration
  "productRegistration.error.encryptionError": "Se produjo un error de cifrado",
  "productRegistration.quickInput.placeholder": "Ingresa nombres o detalles de productos (uno por línea)",
  "productRegistration.quickInput.hint": "Puedes pegar varios elementos a la vez. Las líneas vacías serán ignoradas.",
  "productRegistration.quickInput.disable": "Cambiar a modo de entrada detallada",
  "productRegistration.quickInput.enable": "Cambiar a modo de entrada rápida",
  "productRegistration.mode.detailed": "Modo detallado",
  "productRegistration.mode.quick": "Modo rápido",
  "productRegistration.quickInput.collectDetails": "Recopilar detalles",
  "productRegistration.emptyHint": "Agrega al menos un producto para continuar",
  "productRegistration.form.modalTitle": "Editar producto",
  
  // Grade Assignment
  "gradeAssignment.distribution.doubleClickToView": "Doble clic para ver detalles",
  
  // Criteria Extraction
  "criteriaExtraction.inputFormTitle": "Entrada de criterios de evaluación",
  "criteriaExtraction.inputFormSubtitle": "Ingresa los criterios de evaluación para tu evaluación",
  "criteriaExtraction.productDescriptionsLabel": "Descripciones de productos",
  "criteriaExtraction.productDescriptionPlaceholder": "Ingresa la descripción del producto...",
  "criteriaExtraction.removeDescription": "Eliminar descripción",
  "criteriaExtraction.criteriaListTitle": "Lista de criterios de evaluación",
  "criteriaExtraction.criterionTitlePlaceholder": "Ingresa el título del criterio",
  "criteriaExtraction.criterionDescriptionPlaceholder": "Ingresa la descripción del criterio",
  "criteriaExtraction.addCriterionCard": "Agregar nuevo criterio",
  "criteriaExtraction.editCriterion": "Editar criterio",
  "criteriaExtraction.deleteCriterion": "Eliminar criterio",
  "criteriaExtraction.extracting": "Extrayendo criterios",
  "criteriaExtraction.extractingDescription": "Analizando tu entrada para extraer criterios de evaluación...",
  "criteriaExtraction.step1": "Analizando contenido",
  "criteriaExtraction.step2": "Identificando criterios clave",
  "criteriaExtraction.step3": "Organizando resultados",
  "criteriaExtraction.quickInputPlaceholder": "Ingresa criterios de evaluación o pega contenido para extraer criterios...",
  "criteriaExtraction.addCriterionModalTitle": "Agregar nuevo criterio",
  "criteriaExtraction.criterionTitleLabel": "Título del criterio",
  "criteriaExtraction.criterionDescriptionsLabel": "Descripciones del criterio",
  "criteriaExtraction.removeCriterionDescription": "Eliminar descripción",
  "criteriaExtraction.addCriterionDescriptionButton": "Agregar descripción",
  "criteriaExtraction.addCriterionConfirmButton": "Agregar criterio",
  
  // Comparative Evaluation Quick
  "comparativeEvaluationQuick.cursor.nextStep": "Proceder al siguiente paso",
  "comparativeEvaluationQuick.cursor.nextCriterion": "Proceder al siguiente criterio",
  
  // Preview
  "preview.loadErrorDetail": "Error al cargar la vista previa",
  "preview.invalidUrl": "URL inválida",
  "preview.invalidUrlDetail": "Por favor ingresa una URL válida",
  "preview.loading": "Cargando...",
  "preview.loadError": "Error al cargar",
  "preview.pageLoadError": "La página no se pudo cargar",
  "preview.comment": "Comentario",
  "preview.commentPlaceholder": "Agrega tu comentario...",
  
  // Google Drive
  "googleDrive.searchPlaceholder": "Buscar archivos...",
  "googleDrive.allTypes": "Todos los tipos",
  "googleDrive.documents": "Documentos",
  "googleDrive.spreadsheets": "Hojas de cálculo",
  "googleDrive.presentations": "Presentaciones",
  "googleDrive.sortByName": "Nombre",
  "googleDrive.sortByModified": "Modificado",
  "googleDrive.searchResults": "Resultados de búsqueda para \"{{query}}\"",
  "googleDrive.selectAll": "Seleccionar todo",
  "googleDrive.clearSelection": "Limpiar selección",
  "common.folder": "Carpeta",
  "googleDrive.noSearchResults": "No se encontraron resultados",
  
  // Dashboard
  "dashboard.enterProjectName": "Ingresa el nombre del proyecto",
  
  // AutoSave
  "autoSave.enable": "Habilitar guardado automático",
  "autoSave.currentSetting": "Configuración actual:",
  "autoSave.descriptionShort": "Los datos se guardan automáticamente",
  "autoSave.descriptionLocal": "También se guarda en el almacenamiento local",
  "autoSave.descriptionError": "Los datos se conservan en caso de error",
  
  // Weight
  "weight.currentTotal": "Total actual:",
  
  // CSV Export
  "csvExport.templateRequired": "Por favor ingresa una plantilla",
  "csvExport.exportFailed": "Error al exportar",
  "csvExport.sampleComment": "Este es un comentario de muestra",
  "csvExport.currentUser": "Usuario actual",
  "csvExport.title": "Exportar CSV",
  "csvExport.exportStatus": "Estado de exportación",
  "csvExport.remaining": "Restante:",
  "csvExport.unlimited": "Ilimitado",
  "csvExport.templateLabel": "Plantilla de exportación",
  "csvExport.templatePlaceholder": "Ingresa tu plantilla...",
  "csvExport.templateHelp": "Crea una plantilla usando las variables disponibles",
  "csvExport.availablePlaceholders": "Variables disponibles",
  "csvExport.preview": "Vista previa",
  "csvExport.filename": "Nombre de archivo",
  "csvExport.format": "Formato",
  "csvExport.includeHeader": "Incluir encabezado",
  "csvExport.exporting": "Exportando...",
  
  // Rubric Generation Dialog
  "rubricGeneration.differenceDialog.title": "Explicar las diferencias",
  "rubricGeneration.differenceDialog.progress": "Pregunta {{current}} de {{total}}",
  "rubricGeneration.differenceDialog.question": "¿Qué distingue \"{{gradeA}}\" de \"{{gradeB}}\" para {{criterion}}?",
  "rubricGeneration.differenceDialog.hint": "Por favor describe las diferencias específicas entre estos niveles de evaluación.",
  "rubricGeneration.differenceDialog.placeholder": "Por ejemplo: El nivel A muestra comprensión completa mientras que el nivel B muestra comprensión parcial...",
  "rubricGeneration.differenceDialog.skipAndGenerate": "Omitir y generar",
  "rubricGeneration.differenceDialog.skip": "Omitir",
  "rubricGeneration.differenceDialog.completeAndGenerate": "Completar y generar",
  "rubricGeneration.differenceDialog.next": "Siguiente",
  
  // Product Registration
  "productRegistration.noDetailProvided": "No se proporcionaron detalles",
  "productRegistration.detailsDialog.title": "Detalles del producto",
  "productRegistration.detailsDialog.progress": "Producto {{current}} de {{total}}",
  "productRegistration.detailsDialog.productTitle": "{{title}}",
  "productRegistration.detailsDialog.detailLabel": "Detalles",
  "productRegistration.detailsDialog.detailPlaceholder": "Ingresa detalles o descripción del producto...",
  "productRegistration.detailsDialog.linkLabel": "Enlace de referencia (opcional)",
  "productRegistration.detailsDialog.linkPlaceholder": "https://example.com/product",
  "productRegistration.detailsDialog.hint": "Proporciona detalles para ayudar con la evaluación. Puedes omitir si no es necesario.",
  "productRegistration.detailsDialog.skipAndComplete": "Omitir todo y completar",
  "productRegistration.detailsDialog.skip": "Omitir",
  "productRegistration.detailsDialog.complete": "Completar",
  "productRegistration.detailsDialog.next": "Siguiente",
  "productRegistration.edit.modalTitle": "Editar producto",
  
  // Criteria Extraction Modal
  "criteriaExtraction.edit.modalTitle": "Editar criterio",
  "criteriaExtraction.form.titleLabel": "Título",
  "criteriaExtraction.edit.titlePlaceholder": "Ingresa el título del criterio",
  "criteriaExtraction.form.descriptionLabel": "Descripción",
  "criteriaExtraction.edit.descriptionPlaceholder": "Ingresa la descripción del criterio",
  "criteriaExtraction.form.addDescription": "Agregar descripción",
  "criteriaExtraction.edit.save": "Guardar",
  "criteriaExtraction.edit.cancel": "Cancelar",
  
  // Grade Assignment
  "gradeAssignment.dragOrDoubleClick": "Arrastra los límites o haz doble clic en los productos para ajustar",
  
  // Product Registration Import
  "productRegistration.import.sectionTitle": "Importar",
  "productRegistration.import.googleDrive": "Google Drive",
  "productRegistration.import.localTitle": "Importar desde archivos locales",
  "productRegistration.import.localLabel": "Importar desde archivos locales",
  "productRegistration.import.local": "Archivos locales",
  
  // Final missing translations
  "productRegistration.import.csvShort": "CSV",
  "productRegistration.export.sectionTitle": "Exportar",
  "productRegistration.export.template": "Plantilla",
  "localFolderBrowser.loading": "Cargando...",
  "localFolderBrowser.loadingWithFile": "Cargando {{file}}...",
  "localFolderBrowser.title": "Seleccionar archivos locales",
  "localFolderBrowser.searchPlaceholder": "Buscar archivos...",
  "localFolderBrowser.selectAll": "Seleccionar todo",
  "localFolderBrowser.clearSelection": "Limpiar selección",
  "localFolderBrowser.selectedCount": "{{count}} seleccionado(s)",
  "localFolderBrowser.noFilesFound": "No se encontraron archivos",
  "localFolderBrowser.dropzone.text": "Arrastra y suelta archivos aquí o haz clic para seleccionar",
  "localFolderBrowser.dropzone.acceptedFormats": "Formatos aceptados: .txt, .csv, .docx, .pdf, .xlsx",
  "localFolderBrowser.cancel": "Cancelar",
  "localFolderBrowser.import": "Importar",
  
  // Evaluation guidance messages
  "evaluation.guidance.registerProducts": " Por favor registra los productos a evaluar",
  "evaluation.guidance.completeRegistration": " Completa el registro de productos y haz clic en 'Siguiente'",
  "evaluation.guidance.extractCriteria": " Por favor extrae o añade manualmente los criterios de evaluación",
  "evaluation.guidance.confirmCriteria": " Revisa y edita los criterios, luego haz clic en 'Siguiente'",
  "evaluation.guidance.placeProducts": "💡 Coloca al menos {{count}} productos para cada criterio",
  "evaluation.guidance.placeMoreProducts": "💡 Coloca {{remaining}} productos más para el criterio '{{criterionTitle}}'",
  "evaluation.guidance.comparisonComplete": " Comparaciones requeridas completadas. Haz clic en 'Siguiente' para proceder a la asignación de calificaciones",
  "evaluation.guidance.setGrades": "💡 Por favor establece las calificaciones (A, B, C, etc.) para '{{criterionTitle}}'",
  "evaluation.guidance.gradesComplete": " Asignación de calificaciones completada. Haz clic en 'Siguiente' para generar la rúbrica",
  "evaluation.guidance.rubricGenerated": " La rúbrica ha sido generada. Haz clic en 'Siguiente' para proceder",
  "evaluation.guidance.generateRubric": " Por favor genera la rúbrica",
  "evaluation.guidance.startEvaluation": "💡 ¡Empecemos a evaluar! Simplemente haz clic para colocar los elementos",
  "evaluation.guidance.progress25": "💡 ¡Gran progreso! Casi a la mitad ({{progress}}% completado)",
  "evaluation.guidance.progress50": "💡 ¡Más de la mitad! Sigue así ({{progress}}% completado)",
  "evaluation.guidance.progress75": "💡 ¡75% completado! La meta está cerca",
  "evaluation.guidance.almostDone": "💡 ¡Casi listo! Solo quedan {{unplacedCount}} elementos",
  "evaluation.guidance.allComplete": " Todas las evaluaciones completadas. Haz clic en 'Siguiente' para generar el informe",
  "evaluation.guidance.downloadReport": " Por favor descarga o comparte el informe"
};